import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getAdminCompleteRegistrationPath = () => {
  return urlHelper('/auth/admin/complete-registration/');
};
